// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-893df954]{display:flex;flex-direction:column;margin:1rem 0}.wrapper #title[data-v-893df954]{color:#161616;font-weight:700;font-size:14px}.wrapper #dimensions[data-v-893df954]{color:#6f6f6f;font-size:12px}", ""]);
// Exports
module.exports = exports;
